module.exports = __webpack_public_path__ + "static/media/hc3.d1a2d0c5.png";